<script setup lang="ts">
import { toRefs } from "vue";
import SegmentPartDO = App.Data.Segments.SegmentPartDO;
import { useI18n } from "vue-i18n";
import { useSegmentBuilderStore } from "@/modules/segments/store";
const segmentBuilderState = useSegmentBuilderStore().segmentBuilderState;
const { t } = useI18n();

const props = defineProps<{
	part: SegmentPartDO;
}>();

const { part } = toRefs(props);

const emit = defineEmits(["remove-metric-filter", "edit-metric-filter"]);

const editMetricFilter = () => {
	emit("edit-metric-filter");
};

const removeMetricFilter = () => {
	emit("remove-metric-filter");
};
</script>

<template>
	<v-card
		@click="editMetricFilter()"
		class="w-100 ma-0 pa-0"
		variant="tonal"
		:color="part.type === 'include' ? 'primary' : 'active-secondary'"
	>
		<div class="d-flex">
			<div class="py-4 px-5 w-100 text-caption">
				Select all '<strong>{{
					t(`segments.types.${segmentBuilderState.segment.type}.select`)
				}}</strong
				>' for which the '<strong>{{
					t(`segments.metrics.${part?.metric.name_clean}.action`)
				}}</strong
				>' is '<strong>{{ t(`segments.operators.${part?.operator}`) }}</strong
				>' '<strong>{{
					part?.operator === "between"
						? `${part.values[0]} and ${part.values[1]}`
						: part.values[0]
				}}</strong
				>'
			</div>
			<div class="mr-2">
				<v-btn
					@click.prevent="removeMetricFilter()"
					variant="text"
					:color="part.type === 'include' ? 'primary' : 'active-secondary'"
					icon="mdi-trash-can-outline"
				></v-btn>
			</div>
		</div>
	</v-card>
</template>

<style scoped lang="scss"></style>
